import {
  AccordionItem,
  Text,
  List,
  Stack,
  Heading,
  Strong,
} from 'braid-design-system';
export const SectionF = () => (
  <AccordionItem
    id="section-f"
    label="Section F: Questionnaire Panel with GraphQL"
  >
    <Stack space="gutter">
      <Heading level="4">Functional</Heading>
      <List type="number" start={88}>
        <Text>
          Section F applies if you have chosen to use the Custom Questionnaire
          Panel functionality through the SEEK API.
        </Text>
        <Text>
          <Strong>Custom Questionnaire Panel</Strong> means the panel
          implementation used to programmatically create questionnaires by your
          backend via GraphQL during advertisement creation.
        </Text>
        <Stack space="medium">
          <Text>You acknowledge and agree that:</Text>
          <List type="alpha">
            <Text>
              if you choose to use the Custom Questionnaire Panel, it must be
              made available to all Advertisers. Removal of this panel for any
              Advertiser must be discussed and agreed with us beforehand;
            </Text>
            <Text>
              if you have chosen to embed the Custom Questionnaire Panel, you
              agree to use these questions only for their intended purpose; and
            </Text>
            <Text>
              within the Custom Questionnaire Panel, all our questions returned
              as a result of the query to retrieve questions from us must be
              visible and selectable for the hirer posting the job ad.
            </Text>
          </List>
        </Stack>
      </List>
      <Heading level="4">Messaging / Branding</Heading>
      <List type="number" start={91}>
        <Text>
          Upon successfully integrating the Custom Questionnaire Panel into your
          system, we will review the implementation to ensure the design
          appropriately represents our brand and value proposition. We may
          decide to end your integration with the SEEK API if it determines in
          our sole discretion, that the design implemented by you does not
          appropriately represent our brand and value proposition.
        </Text>
      </List>
    </Stack>
  </AccordionItem>
);
